// The wfm.gms.work -> e-ops.gms.work rename, kept in one file so retiring the old domain is one
// edit rather than a hunt through components.
//
// Both hosts serve the same Render static site during the transition. When wfm.gms.work comes off
// that service, planned for 2026-09-22:
//   - delete LEGACY_HOST and drop it from PRODUCTION_HOSTS
//   - delete components/Layout/LegacyDomainBanner.{js,css} and its mount in App.js
// Everything else narrows on its own.

export const PRODUCTION_HOST = 'e-ops.gms.work';
export const LEGACY_HOST = 'wfm.gms.work';
export const PRODUCTION_URL = `https://${PRODUCTION_HOST}`;

/** Hosts that ARE production. A production host missing from this set is treated as a test
 *  environment and told so in a banner, so both live domains belong here until the old one goes. */
export const PRODUCTION_HOSTS = new Set([PRODUCTION_HOST, LEGACY_HOST]);

const currentHost = () =>
  (typeof window === 'undefined' ? '' : String(window.location.hostname || '')).toLowerCase();

export const isProductionHost = () => PRODUCTION_HOSTS.has(currentHost());

/** True only on the domain being retired. */
export const isLegacyHost = () => currentHost() === LEGACY_HOST;

/** The same page on the new domain. Carrying the path over means someone following the banner from
 *  a deep link or an old bookmark lands where they already were, not back at the home page. */
export const productionUrlForCurrentPage = () => {
  if (typeof window === 'undefined') return PRODUCTION_URL;
  const { pathname, search, hash } = window.location;
  return `${PRODUCTION_URL}${pathname || '/'}${search || ''}${hash || ''}`;
};
